import { jsx as _jsx } from "react/jsx-runtime";
import { PdfViewer } from '~/components/PdfViewer/PdfViewer';
import { QuillViewerWithFetch } from '~/components/QuillViewerWithFetch/QuillViewerWithFetch';
import { RichTextViewerWithFetch } from '~/components/RichTextViewerWithFetch/RichTextViewerWithFetch';
import { useStoreActions } from '~/contexts';
import { useLegalTerms } from '~/hooks/reactQuery/queries/useLegalTerms';
export function TermsOfServiceContent(param) {
    let { relationship, termsOfService } = param;
    const { api } = useStoreActions();
    const { legalTerms } = useLegalTerms();
    const { type } = termsOfService;
    if (type === 'pdf') {
        return /*#__PURE__*/ _jsx(PdfViewer, {
            hideSinglePageLoader: true,
            getFileUrl: async ()=>await api.business.getLegalTermsDownloadURL(termsOfService.pdf.pdfName, relationship.vendor.id),
            pdfUniqueName: termsOfService.pdf.pdfName
        });
    }
    if (type === 'quill') {
        const textId = termsOfService.quill.textId;
        return /*#__PURE__*/ _jsx(QuillViewerWithFetch, {
            queryKey: textId !== null && textId !== void 0 ? textId : undefined,
            fetchContent: async ()=>{
                var _ref;
                var _legalTerms_find;
                if (textId) {
                    const { value } = await api.texts.getLegalTermsRichTextContent(relationship.id, textId);
                    return value;
                }
                return (_ref = (_legalTerms_find = legalTerms.find((lt)=>lt.id === termsOfService.legalTermsId)) === null || _legalTerms_find === void 0 ? void 0 : _legalTerms_find.richTextContent) !== null && _ref !== void 0 ? _ref : [];
            }
        });
    }
    const textId = termsOfService.richText.textId;
    return /*#__PURE__*/ _jsx(RichTextViewerWithFetch, {
        queryKey: textId !== null && textId !== void 0 ? textId : undefined,
        fetchText: async ()=>{
            var _ref;
            var _legalTerms_find;
            if (textId) {
                const { value } = await api.texts.getLegalTermsRichTextContent(relationship.id, textId);
                return value;
            }
            return (_ref = (_legalTerms_find = legalTerms.find((lt)=>lt.id === termsOfService.legalTermsId)) === null || _legalTerms_find === void 0 ? void 0 : _legalTerms_find.richTextContent) !== null && _ref !== void 0 ? _ref : [];
        }
    });
}
